import React from 'react';

// Embeds an external website in an iframe. Note: many sites block this via
// X-Frame-Options / Content-Security-Policy (frame-ancestors) and simply
// won't render here — that's a restriction the target site sets, not
// something we can override from this app.
const SiteEmbed = ({
  url,
  title = 'Embedded site',
  height = '80vh',
  className = ''
}) => {
  if (!url) {
    return null;
  }

  return (
    // ring instead of border -- same hairline-vanishing issue as the
    // homepage use-case cards (see Home.jsx), where a thin `border` on a
    // rounded element can round to 0 physical pixels on some edges
    // depending on display scaling/zoom. A ring (box-shadow) doesn't hit
    // that bug. Plain black, not brand blue -- just enough to mark the
    // embed boundary without drawing attention to itself.
    //
    // Deliberately NOT ring-inset: an inset ring is a box-shadow painted
    // as part of this div's own box decoration, which paints before its
    // children. The iframe fills this div's content box edge-to-edge with
    // no padding, so once the embedded site's own background renders, it
    // paints right over the inset ring -- looked fine for a moment on
    // load, then got covered as soon as the target site finished loading.
    // A non-inset ring is painted outside this div's border box instead,
    // where the iframe's content never reaches, and isn't clipped by this
    // div's own overflow-hidden (that only clips children, not the box's
    // own outward decorations).
    <div className={`w-full overflow-hidden rounded-xl shadow-lg ring-2 ring-black ${className}`}>
      <iframe
        src={url}
        title={title}
        style={{ height, width: '100%', border: 0 }}
        loading="lazy"
      />
    </div>
  );
};

export default SiteEmbed;
